import { RiskUnitType } from '..'

export const riskAttributesWithUnits: Array<{
  attribute: string
  displayUnit: string
  unit: RiskUnitType
}> = [
  { attribute: 'Risk', displayUnit: 'RU/yr', unit: RiskUnitType.TotalRisk },
  {
    attribute: 'Risk Density',
    displayUnit: 'RU/mi/yr',
    unit: RiskUnitType.RiskDensity
  }
]
